export enum CheckoutProvider {
  Adyen = 'adyen',
  AuthorizeDotNet = 'authorize.net',
  BackyardStorage = 'backyard storage',
  GreenSky = 'green sky',
  RtoNational = 'rto national', // Needed to keep compatibility, should use RtoNationalFlexLease instead.
  RtoNationalFlexLease = 'rto national - flex lease',
  RtoNationalInstallment = 'rto national - installment',
  RtoNationalCashSale = 'rto national - cash sale',
  GrovePropertiesRTO = 'grove properties rto',
  InsightRTO = 'insight rto',
  Stripe = 'stripe',
  ExternalCheckoutProvider = 'external checkout provider',
}
